export enum ErrorDomainEnum {
  AUTH = 'AUTH',
  FALLBACK = 'FALLBACK',
  FILE = 'FILE',
  USER = 'USER',
}
